// src/components/copilot/index.tsx
import {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo
} from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Copilot = ({
  url,
  fabHide,
  onEvent,
  right = 16,
  bottom = 150
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [socketJoined, setSocketJoined] = useState(false);
  const [conversationJoined, setConversationJoined] = useState(false);
  const [fabStatus, setFabStatus] = useState("initial");
  const [timerStatus, setTimerStatus] = useState(
    "init"
  );
  const [fabWidth, setFabWidth] = useState(0);
  const [fabMessage, setFabMessage] = useState("");
  const [messageType, setMessageType] = useState("expand");
  const iframeRef = useRef(null);
  const fabLabelRef = useRef(null);
  const ringIcon = "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";
  useEffect(() => {
    if (fabMessage && messageType === "expand") {
      setTimerStatus("init");
      const showTimer = setTimeout(() => {
        setTimerStatus("show");
      }, 500);
      const widthTimer1 = setTimeout(() => {
        updateFabWidth();
      }, 600);
      const hideTimer = setTimeout(() => {
        setTimerStatus("hide");
      }, 4300);
      const widthTimer2 = setTimeout(() => {
        updateFabWidth();
      }, 4350);
      return () => {
        clearTimeout(showTimer);
        clearTimeout(widthTimer1);
        clearTimeout(hideTimer);
        clearTimeout(widthTimer2);
      };
    }
  }, [fabMessage, messageType]);
  const updateFabWidth = () => {
    if (fabLabelRef.current) {
      setFabWidth(fabLabelRef.current.offsetWidth);
    }
  };
  const completelyLoaded = useMemo(() => {
    return isIframeLoaded && socketJoined && conversationJoined;
  }, [isIframeLoaded, socketJoined, conversationJoined]);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 650px)");
    setIsMobile(mediaQuery.matches);
    const handleResize = () => {
      setIsMobile(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);
  useEffect(() => {
    setMessageType("expand");
    setFabStatus("initial");
    if (completelyLoaded) {
      const initTimer = setTimeout(() => {
        setFabMessage("We're here if you need help!");
        setFabStatus("pending");
      }, 500);
      return () => clearTimeout(initTimer);
    }
  }, [isIframeLoaded, socketJoined, conversationJoined]);
  useEffect(() => {
    if (isMobile && isOpen) {
      const originalScrollY = window.scrollY;
      const originalOverflow = document.body.style.overflow;
      document.body.style.position = "fixed";
      document.body.style.top = `-${originalScrollY}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.body.style.overflow = originalOverflow;
        window.scrollTo(0, originalScrollY);
      };
    }
  }, [isMobile, isOpen]);
  const handleToggleChat = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (newState) {
      sendMessageToIframe({ type: "copilotOpened", data: {} });
    } else {
      sendMessageToIframe({ type: "copilotClosed", data: {} });
    }
  };
  const sendMessageToIframe = (message) => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(message, "*");
    }
  };
  const sendMessage = useCallback((messageContent) => {
    if (!messageContent.trim()) return;
    console.debug("Sending message to iframe:", messageContent);
    const fullMessage = {
      content: [
        {
          type: "widget",
          widget: {
            widgetId: "text",
            content: messageContent
          }
        }
      ],
      status: "sent",
      role: "user",
      meta: {
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        source: "copilot"
      }
    };
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: "sendMessage",
          payload: {
            message: fullMessage,
            messageContent,
            timestamp: (/* @__PURE__ */ new Date()).toISOString()
          }
        },
        "*"
      );
    }
  }, []);
  const setContext = (context) => {
    if (setContext && typeof setContext === "function") {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          {
            type: "setContext",
            payload: {
              context
            }
          },
          "*"
        );
      }
    }
  };
  const getSummary = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ type: "get-summary" }, "*");
    }
  };
  const open = () => {
    setIsOpen(true);
    onEvent("openCopilot", { message: "open" });
  };
  const close = () => {
    setIsOpen(false);
    onEvent("closeCopilot", { message: "close" });
  };
  useEffect(() => {
    if (!window.copilot) {
      window.copilot = {};
    }
    window.copilot.sendMessage = sendMessage;
    window.copilot.setContext = setContext;
    window.copilot.open = open;
    window.copilot.close = close;
    window.copilot.getSummary = getSummary;
    return () => {
      delete window.copilot.sendMessage;
      delete window.copilot.setContext;
      delete window.copilot.open;
      delete window.copilot.close;
      delete window.copilot.getSummary;
    };
  }, [sendMessage, setContext]);
  useEffect(() => {
    const handleMessage = (event) => {
      const { type, payload } = event.data;
      switch (type) {
        case "closeCopilot":
          if (isOpen) {
            handleToggleChat();
            onEvent("closeCopilot", payload);
          }
          break;
        case "openCopilot":
          if (!isOpen) {
            handleToggleChat();
            onEvent("openCopilot", payload);
          }
          break;
        case "connection-initialised-completely":
          setSocketJoined(true);
          onEvent("connection-initialised-completely", payload);
          break;
        case "join-conversation":
          setConversationJoined(true);
          onEvent("join-conversation", payload);
          break;
        case "summary":
          onEvent("summary", payload);
          break;
        case "message":
          onEvent("message", payload);
          break;
        case "login":
          onEvent("login", payload);
          break;
        case "agent":
          onEvent("agent", payload);
          break;
        case "feedbackCopilot":
          onEvent("feedbackCopilot", payload);
          break;
        default:
          onEvent(type, payload);
          console.log("Received unhandled message from iframe:", event.data);
          break;
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [isOpen]);
  const handleDismiss = () => {
    setFabMessage("");
    setFabStatus("initial");
  };
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleToggleChat();
    }
  };
  const calculateFabWidth = () => {
    if (messageType === "expand" && fabStatus === "pending") {
      if (timerStatus === "show" && fabMessage) {
        return fabWidth !== 0 ? `${fabWidth + 64}px` : `${fabWidth + 52}px`;
      } else if (timerStatus === "hide") {
        return fabWidth !== 0 ? `${fabWidth + 64}px` : `${fabWidth + 52}px`;
      }
    }
    return "56px";
  };
  return /* @__PURE__ */ jsxs("div", { className: "acko-copilot-container", children: [
    isMobile && /* @__PURE__ */ jsx(
      "div",
      {
        className: `fixed top-0 left-0 w-full h-full bg-[#161a2652] backdrop-blur-lg z-[999998] transition-opacity duration-200 ${isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`,
        onClick: handleBackdropClick
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `fixed overflow-hidden drop-shadow-[0_10px_25px_rgba(64,49,91,0.54)] z-[999999] ${isMobile ? `top-0 left-0 w-full h-full ${isOpen ? "pointer-events-auto animate-chat_slide_up" : "pointer-events-none animate-chat_slide_down"}` : `right-[16px] rounded-2xl ${isOpen ? "pointer-events-auto animate-chat_slide_up" : "pointer-events-none animate-chat_slide_down"}`}`,
        style: {
          width: isMobile ? "100%" : "375px",
          height: isMobile ? "100dvh" : "70vh",
          bottom: isMobile ? "0px" : bottom,
          right: isMobile ? "0px" : right
        },
        children: /* @__PURE__ */ jsx(
          "iframe",
          {
            ref: iframeRef,
            src: url,
            className: "w-full h-full",
            referrerPolicy: "origin",
            onLoad: () => setIsIframeLoaded(true),
            title: "Acko Copilot Chat"
          }
        )
      }
    ),
    !fabHide && !isOpen && /* @__PURE__ */ jsxs(
      "div",
      {
        className: "fixed z-[999999] rounded-full cursor-pointer",
        style: {
          right,
          bottom
        },
        children: [
          fabStatus === "pending" && messageType !== "expand" || fabStatus === "pending" && messageType === "expand" && timerStatus === "hide" ? /* @__PURE__ */ jsxs("span", { className: "absolute flex h-2 w-2 left-0 top-[5px] z-[1000000]", children: [
            /* @__PURE__ */ jsx("span", { className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" }),
            /* @__PURE__ */ jsx("span", { className: "relative inline-flex rounded-full h-2 w-2 bg-red-500" })
          ] }) : null,
          fabMessage && messageType === "bubble" && /* @__PURE__ */ jsxs(
            "div",
            {
              className: "absolute bottom-[70px] right-0 max-w-[400px] p-3 rounded-lg bg-slate-700 text-slate-300 animate-pulse mb-2",
              onClick: handleDismiss,
              children: [
                fabMessage.length > 100 ? fabMessage.slice(0, 97) + "..." : fabMessage,
                /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 right-4 transform -translate-x-1/2 translate-y-full w-0 h-0 border-l-8 border-l-transparent border-t-8 border-t-slate-700 border-r-8 border-r-transparent" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "button",
            {
              onClick: handleToggleChat,
              className: "relative flex px-[10px] rounded-3xl bg-gradient-to-r from-[#fff0f7] to-[#ebe8ff] items-center shadow-[0_6px_12px_#7300ff24] border-b border-[#b191ed] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:border-none transition-[width] duration-700 ease-in-out ",
              style: {
                width: calculateFabWidth(),
                minWidth: "56px",
                height: "50px"
              },
              "aria-label": isOpen ? "Close chat" : "Open chat",
              children: [
                messageType === "expand" && fabMessage && timerStatus === "show" && /* @__PURE__ */ jsx(
                  "span",
                  {
                    ref: fabLabelRef,
                    className: "whitespace-nowrap text-slate-800 text-sm opacity-0 animate-appear_message animation-delay-500",
                    children: fabMessage
                  }
                ),
                messageType === "expand" && timerStatus === "hide" && /* @__PURE__ */ jsx(
                  "span",
                  {
                    ref: fabLabelRef,
                    className: "whitespace-nowrap text-slate-800 text-sm opacity-0 animate-appear_opacity",
                    children: "Chat with us"
                  }
                ),
                /* @__PURE__ */ jsx("div", { className: "h-7 w-7 absolute right-[12px] top-[10px]", children: /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: `data:image/png;base64,${ringIcon}`,
                    alt: "Chat",
                    className: `h-7 w-7 ${!completelyLoaded ? "opacity-70 grayscale" : ""}`
                  }
                ) })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx("style", { children: `
          @keyframes appear_opacity {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          
          @keyframes chat_slide_up {
            0% {
              transform: translateY(100%);
              opacity: 0;
            }
            20% {
              transform: translateY(30%);
              opacity: 0;
            }
            100% {
              transform: translateY(0%);
              opacity: 1;
            }
          }
          
          @keyframes chat_slide_down {
            0% {
              transform: translateY(0%);
              opacity: 1;
            }
            30% {
              transform: translateY(60%);
              opacity: 0;
            }
            100% {
              transform: translateY(100%);
              opacity: 0;
            }
          }
          
          .animate-appear_message {
            animation: appear_opacity 0.8s ease-in-out 0.5s forwards;
          }
          
          .animate-appear_opacity {
            animation: appear_opacity 0.4s ease-in-out forwards;
          }
          
          .animation-delay-500 {
            animation-delay: 0.5s;
          }
          
          .animate-chat_slide_up {
            animation: chat_slide_up 0.5s ease-in-out forwards;
          }
          
          .animate-chat_slide_down {
            animation: chat_slide_down 0.5s ease-in-out forwards;
          }
        ` })
  ] });
};
export {
  Copilot
};
//# sourceMappingURL=index.mjs.map